<template title="Conservation Purposes Statement">
  <div class="card mb-2" v-if="conservationValuesStatement">
    <div class="card-header bg-primary text-white d-flex">
      <a v-b-toggle="`collapse-conservation-values-card`" class="collapse-icon c-pointer">
        <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
        <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
      </a>
      <span class="font-weight-bold">Conservation Values Statement</span>
    </div>
    <b-collapse :id="`collapse-conservation-values-card`">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            {{ conservationValuesStatement }}
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>

import CollapseControl from '@/mixins/CollapseControl';

export default {
  name: 'ConservationValuesCard',
  props: [
    'conservationValuesStatement',
  ],
  mixins: [CollapseControl],
};
</script>
